module.exports = __webpack_public_path__ + "static/img/nodata.bf3ac2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nodata.png
// module id = f0hK
// module chunks = 2